var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 2.5C5.71836 2.5 2.5 5.71836 2.5 9.6875C2.5 13.6566 5.71836 16.875 9.6875 16.875C13.6566 16.875 16.875 13.6566 16.875 9.6875C16.875 5.71836 13.6566 2.5 9.6875 2.5Z",
    stroke: "#4EA6FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 8.59277H9.84375V13.124",
    stroke: "#4EA6FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 13.2803H11.5625",
    stroke: "#4EA6FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 5.07715C9.48663 5.07715 9.29027 5.13671 9.12325 5.24831C8.95623 5.35991 8.82606 5.51853 8.74918 5.70411C8.67231 5.88969 8.6522 6.0939 8.69139 6.29091C8.73058 6.48792 8.82731 6.66889 8.96934 6.81093C9.11138 6.95297 9.29235 7.04969 9.48936 7.08888C9.68637 7.12807 9.89058 7.10796 10.0762 7.03109C10.2617 6.95422 10.4204 6.82404 10.532 6.65702C10.6436 6.49001 10.7031 6.29364 10.7031 6.09277C10.7031 5.82341 10.5961 5.56508 10.4057 5.37462C10.2152 5.18415 9.95686 5.07715 9.6875 5.07715Z",
    fill: "#4EA6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircleOutline);
export default __webpack_public_path__ + "static/media/information-circle-outline.fd34a0e42d9bc008185a9324f0846149.svg";
export { ForwardRef as ReactComponent };